import { createSelector } from 'reselect';
import { data as financialPlanSelector } from '../../FinancialPlanSelector';
import { selectedGoal } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { populateAssumptionsLabel } from './assumptionsConts';

export const isMarried = goal => (
  !!goal.LifeInsurance.SpouseName
);
export const hasChildren = GeneralAssumptions => (
  !!GeneralAssumptions.Children
);
export const principalName = goal => (
  goal.LifeInsurance.PrincipalName
);
export const spouseName = goal => (
  goal.LifeInsurance.SpouseName
);

export const isMarriedSelector = createSelector(
  selectedGoal,
  isMarried,
);

export const hasChildrenSelector = createSelector(
  financialPlanSelector,
  ({ GeneralAssumptions }) => hasChildren(GeneralAssumptions),
);

export const principalNameSelector = createSelector(
  selectedGoal,
  principalName,
);

export const spouseNameSelector = createSelector(
  selectedGoal,
  spouseName,
);

export const lifeInsuranceInsuranceAssumptions = (goal, GeneralAssumptions) => {
  const { GoalAssumptions: { LifeInsurance } } = goal;

  if (isMarried(goal)) {
    return LifeInsurance.Married;
  }

  if (hasChildren(GeneralAssumptions)) {
    return LifeInsurance.SingleWithChildren;
  }

  return LifeInsurance.SingleWithoutChildren;
};

export const insuranceAssumptions = (goal, GeneralAssumptions) => {
  const lifeInsuranceAssumptions = lifeInsuranceInsuranceAssumptions(goal, GeneralAssumptions);
  return {
    ...goal.GoalAssumptions.LongTermCare,
    ...lifeInsuranceAssumptions,
  };
};

export const insuranceAssumptionsValuesSelector = createSelector(
  selectedGoal,
  financialPlanSelector,
  (goal, financialPlan) => (
    insuranceAssumptions(goal, financialPlan.GeneralAssumptions)
  ),
);

export const insuranceAssumptionsLabelPopulated = createSelector(
  isMarriedSelector,
  hasChildrenSelector,
  principalNameSelector,
  spouseNameSelector,
  populateAssumptionsLabel,
);

// Print AUX
export const insuranceAssumptionsLabelPopulatedPrint = (goal, GeneralAssumptions) => {
  return populateAssumptionsLabel(
    isMarried(goal),
    hasChildren(GeneralAssumptions),
    principalName(goal),
    spouseName(goal),
  );
};
